import { useContext, useEffect, useRef } from "react";
import Layout from "../layouts/Layout";
import "./HomePage.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Context } from "../context/Context";
import PlanningList from "../components/PlaningList";
import { Link } from "react-router-dom";
import "./PlanningPage.css";

const PlanningPage = () => {
  const { page, setPage, authUser } = useContext(Context);

  useEffect(() => {
    setPage({
      name: "برنامه ریزی",
      slug: "planning",
    });
  }, []);
  return (
    <HelmetProvider>
      <Helmet>
        <title>{page.name}</title>
      </Helmet>
        <div className="container-xxl flex-grow-1 container-p-y">
          {/* Layout Demo */}
          <div className="col-12 col-md-10 col-lg-8 w-100 h-100 mx-auto">
            <div
              className="card h-100"
              style={{ backgroundColor: "#fff0", boxShadow: "none" }}
            >
              <div className="card-header d-flex align-items-center justify-content-between border-bottom p-0 pt-2">
                <h5>زمان‌بندی‌ها</h5>
                {authUser.is_admin ? (
                  <Link
                    type="button"
                    className="btn btn-icon btn-success-app"
                    to={"/planning/schedule"}
                  >
                    <i className="bx bx-plus"></i>
                  </Link>
                ) : null}
              </div>
              <div className="card-body scrollbar mt-3">
                <PlanningList />
              </div>
            </div>
          </div>
          {/*/ Layout Demo */}
        </div>
    </HelmetProvider>
  );
};

export default PlanningPage;
